import React from "react";
import { Helmet } from "react-helmet";
// import RecentNewsCard from "../components/blog_list/recent_news_card";
export default function BlogDetail() {
    // scroll to top on page load
    React.useEffect(() => {
        window.scrollTo(0, 0);
    }, []);
    const recent_news_card_data = [
        // {
        //     thumb_img: "assets/img/blog/dec-2025-thumb.avif",
        //     title: "How CGES Coins Work and How to Redeem Them",
        //     date: "05 January",
        // },
        // {
        //     thumb_img: "assets/img/blog/dec-2025-thumb.avif",
        //     title: "Why Casual Gamers Are the Future of Esports",
        //     date: "05 January",
        // },
        // {
        //     thumb_img: "assets/img/blog/dec-2025-thumb.avif",
        //     title: "How Beginners Can Start Winning on CGES in 7 Days",
        //     date: "05 January",
        // },
        // {
        //     thumb_img: "assets/img/blog/dec-2025-thumb.avif",
        //     title: "CGES MVP Season: Rules, Rewards & Reset Explained",
        //     date: "05 January",
        // },
    ]
    return (
        <>
        <Helmet>
        <title>Top 3 MVP Champions Revealed – December 2025 | CGES.CLUB</title>

        <meta
          name="description"
          content="Discover the Top 3 MVP Champions of December 2025 on CGES.CLUB. See leaderboard winners, MVP points, rewards, and season highlights."
        />

        <meta
          name="keywords"
          content="CGES MVP Winners, December 2025 MVP, MVP Champions, CGES Leaderboard, Casual Esports Winners, CGES Season"
        />

        {/* Open Graph */}
        <meta property="og:title" content="Top 3 MVP Champions Revealed – December 2025" />
        <meta
          property="og:description"
          content="Top 3 CGES MVP Champions of December 2025 revealed. View leaderboard results, MVP points, and rewards."
        />
        <meta property="og:type" content="article" />
        <meta property="og:site_name" content="CGES.CLUB" />
        <meta property="og:image" content="https://cges.club/assets/img/blog/mvp-dec-2025.avif" />

        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Top 3 MVP Champions – December 2025" />
        <meta
          name="twitter:description"
          content="Meet the Top 3 MVP Champions of December 2025 on CGES.CLUB."
        />
        <meta name="twitter:image" content="https://cges.club/assets/img/blog/mvp-dec-2025.avif" />
      </Helmet>
            <div className="blog-area pd-top-120">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-8">
                            <div className="blog-details-page-content">
                                <div className="single-blog-inner style-large">
                                    <div className="thumb mb-4">
                                        <img className="w-100" src="../assets/img/blog/dec-2025-blog.avif" alt="img" />
                                    </div>
                                    <div className="details p-0">
                                        {/* <div className="cat pt-2">
                                            <a href="#">Victory</a>
                                        </div> */}
                                        <ul className="blog-meta">
                                            <li><i className="far fa-user"></i> By Admin</li>
                                            <li><i className="far fa-calendar-alt"></i> 5th January 2026</li>
                                        </ul>
                                        <h2 className="title">Top 3 MVP Champions Revealed December 2025</h2>
                                        <p>
                                            The December 2025 MVP Season on CGES.CLUB has officially concluded, bringing an exciting month of casual esports competition to a close. Players from across the platform competed daily, earning MVP Points through consistent performance, strategic gameplay, and active participation.
                                        </p>
                                        <p>
                                            The December 2025 MVP Season on CGES.CLUB has officially concluded, bringing an exciting month of casual esports competition to a close.
                                        </p>

                                        <blockquote className="text-center">
                                            <p>
                                                🥇 Sundar – 5,075 MVP Points<br />
                                                🥈 Warking – 3,300 MVP Points<br />
                                                🥉 Harish – 1,230 MVP Points
                                            </p>
                                        </blockquote>
                                        <p>
                                            After weeks of intense matches and leaderboard battles, only three players managed to rise above the rest. These Top 3 MVP Champions showcased dedication, skill, and perseverance, proving that casual gamers can achieve remarkable success on CGES.
                                        </p>

                                        <blockquote className="text-center">
                                            <p>
                                                “Consistency, smart play, and daily participation are what separate MVP champions from the rest.”
                                            </p>
                                        </blockquote>

                                        <h4 className="title">
                                            <a href="blog-details.html">December 2025 MVP Season Highlights</a>
                                        </h4>

                                        <p>
                                            Throughout the month, players earned MVP Points by competing in multiple tournaments, maintaining strong win rates, and staying active on the platform. The December season featured high engagement, competitive leaderboards, and exciting rewards for the top performers.
                                        </p>

                                        <div className="row mt-4">
                                            <div className="col-md-4 mb-3 mb-md-0">
                                                <div className="thumb">
                                                    <img src="https://d2r5hrlw4m5nor.cloudfront.net/mvp/dec_25/MVP_Reward_1.avif" alt="img" />
                                                </div>
                                            </div>
                                            <div className="col-md-4 mb-3 mb-md-0">
                                                <div className="thumb">
                                                    <img src="https://d2r5hrlw4m5nor.cloudfront.net/mvp/dec_25/MVP_Reward_2.avif" alt="img" />
                                                </div>
                                            </div>
                                            <div className="col-md-4 mb-3 mb-md-0">
                                                <div className="thumb">
                                                    <img src="https://d2r5hrlw4m5nor.cloudfront.net/mvp/dec_25/MVP_Reward_3.avif" alt="img" />
                                                </div>
                                            </div>
                                        </div>
                                        <p>
                                            The Top 3 MVP Champions of December 2025 were rewarded for their outstanding performance and consistency. Their journey serves as inspiration for new and existing players aiming to climb the leaderboard in upcoming MVP seasons.
                                        </p>
                                        <div className="tag-and-share d-flex justify-content-between">
                                            {/* <div className="tags">
                                                <strong>Tags : </strong>
                                                <a href="#">Crazy Game, </a>
                                                <a href="#">Post Type</a>
                                            </div> */}
                                            <div className="blog-share">
                                                <strong>Share : </strong>
                                                <ul>

                                                    <li>
                                                        <a
                                                            className="whatsapp"
                                                            href="https://wa.me/?text=%F0%9F%8F%86%20CGES%20Top%203%20MVP%20Champions%20%E2%80%93%20December%202025!%0ACheck%20out%20the%20winners%20and%20their%20rewards%20%F0%9F%91%87%0Ahttps://cges.club/blog-details/cges-top3-mvp-champions-december-2025"
                                                            target="_blank"
                                                            rel="noopener noreferrer"
                                                        >
                                                            <i className="fab fa-whatsapp"></i>
                                                        </a>
                                                    </li>


                                                    <li>
                                                        <a
                                                            className="instagram"
                                                            href="https://www.instagram.com/"
                                                            target="_blank"
                                                            rel="noopener noreferrer"
                                                            title="Copy link and share on Instagram"
                                                        >
                                                            <i className="fab fa-instagram"></i>
                                                        </a>
                                                    </li>


                                                    <li>
                                                        <a
                                                            className="twitter"
                                                            href="https://twitter.com/intent/tweet?url=https://cges.club/blog-details/cges-top3-mvp-champions-december-2025&text=Check%20out%20CGES%20Top%203%20MVP%20Champions%20December%202025!"
                                                            target="_blank"
                                                            rel="noopener noreferrer"
                                                        >
                                                            <i className="fab fa-twitter"></i>
                                                        </a>
                                                    </li>


                                                    <li>
                                                        <a
                                                            className="linkedin"
                                                            href="https://www.linkedin.com/sharing/share-offsite/?url=https://cges.club/blog-details/cges-top3-mvp-champions-december-2025"
                                                            target="_blank"
                                                            rel="noopener noreferrer"
                                                        >
                                                            <i className="fab fa-linkedin"></i>
                                                        </a>
                                                    </li>


                                                    <li>
                                                        <a
                                                            className="copy"
                                                            href="#"
                                                            onclick="copyLink(event)"
                                                            title="Copy Link"
                                                        >
                                                            <i className="fas fa-link"></i>
                                                        </a>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {/* <div className="blog-author d-flex align-self-center">
                                    <div className="thumb me-4">
                                        <img src="assets/img/blog/author.avif" alt="img"/>
                                    </div>
                                    <div className="details align-self-center">
                                        <h4 className="name">Arika Mark</h4>
                                        <p>We think your skin should look and refhed matted Nourish your outecon secture’arew inner deauty hits like</p>
                                        <div className="social me-2">
                                            <a className="me-2" href="#"><i className="fab fa-twitter"></i></a>
                                            <a className="me-2" href="#"><i className="fab fa-linkedin"></i></a>
                                            <a className="me-2" href="#"><i className="fab fa-instagram"></i></a>
                                        </div>
                                    </div>
                                </div> */}
                                {/* <div className="blog-comment">
                                    <h4 className="mb-2">Leave a Comments</h4>
                                    <p>Your E-mail address not be published</p>
                                    <ul className="comment-list mt-lg-4 pt-2 mt-4">
                                        <li className="comment">
                                            <div className="comment-body">
                                                <footer className="comment-meta">
                                                    <div className="comment-author vcard">
                                                        <img className="avatar" alt="img" src="assets/img/blog/author.avif"/>
                                                            <a href="#" rel="external nofollow ugc" className="url fw-600  tt-uppercase me-2">Mike Dooley</a>
                                                            <span>25.08.2024.</span>
                                                    </div>
                                                </footer>
                                                <div className="comment-content mt-2">
                                                    <p>Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classNameical Latin literature from 45 BC, making it over 2000 years old. RichardClintock</p>
                                                </div>
                                                <div className="reply">
                                                    <a rel="nofollow" className="comment-reply-link" href="#">Reply <i className="fa fa-reply"></i></a>
                                                </div>
                                            </div>
                                        </li>
                                        <li className="comment">
                                            <div className="comment-body">
                                                <footer className="comment-meta">
                                                    <div className="comment-author vcard">
                                                        <img className="avatar" alt="img" src="assets/img/blog/author2.avif"/>
                                                            <a href="http://example.org/" rel="external nofollow ugc" className="url fw-600 tt-uppercase me-2">John Κώστας Doe Τάδε</a>
                                                            <span>25.08.2024.</span>
                                                    </div>
                                                </footer>
                                                <div className="comment-content mt-2">
                                                    <p>Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classNameical Latin literature from 45 BC, making it over 2000 years old. RichardClintock</p>
                                                </div>
                                                <div className="reply">
                                                    <a rel="nofollow" className="comment-reply-link" href="#">Reply <i className="fa fa-reply"></i></a>
                                                </div>
                                            </div>
                                        </li>
                                    </ul>
                                </div> */}
                                {/* <form className="blog-comment-form">
                                    <div className="mb-3">
                                        <h4>Leave a Reply</h4>
                                    </div>
                                    <div className="row">
                                        <div className="col-12">
                                            <div className="single-input-inner style-border">
                                                <textarea placeholder="Message"></textarea>
                                            </div>
                                        </div>
                                        <div className="col-lg-6">
                                            <div className="single-input-inner style-border">
                                                <input type="text" placeholder="Name"/>
                                            </div>
                                        </div>
                                        <div className="col-lg-6">
                                            <div className="single-input-inner style-border">
                                                <input type="text" placeholder="Email"/>
                                            </div>
                                        </div>
                                        <div className="col-lg-12">
                                            <div className="single-input-inner style-border">
                                                <input type="text" placeholder="Subject"/>
                                            </div>
                                        </div>
                                        <div className="col-12">
                                            <input type="checkbox"/>
                                                Save my name, email, and website in this browser for the next time I comment.
                                        </div>
                                        <div className="col-12 mt-4">
                                            <button className="btn btn-base border-radius-5">Post Comment</button>
                                        </div>
                                    </div>
                                </form> */}
                            </div>
                        </div>
                        <div className="col-lg-4 col-12">
                            <div className="td-sidebar">
                                {/* <div className="widget widget_author">
                                    <div className="thumb">
                                        <img src="assets/img/widget/author.avif" alt="blog"/>
                                    </div>
                                    <div className="details">
                                        <h4>ABOUT AUTHOR</h4>
                                        <p className="mb-4">We think your skn should looresk referyd matter Nourish yours outecwo resnsectr  our essential products</p>
                                        <img src="assets/img/widget/signature.avif" alt="blog"/>
                                    </div>
                                </div> */}
                                {/* <div className="widget widget_catagory">
                                    <h4 className="widget-title">Catagory</h4>
                                    <ul className="catagory-items">
                                        <li><a href="blog.html"><i className="fas fa-caret-right"></i> Business <span>3</span></a></li>
                                        <li><a href="blog.html"><i className="fas fa-caret-right"></i> Finance <span>7</span></a></li>
                                        <li><a href="blog.html"><i className="fas fa-caret-right"></i> Web Design <span>2</span></a></li>
                                        <li><a href="blog.html"><i className="fas fa-caret-right"></i> Counsiling <span>3</span></a></li>
                                        <li><a href="blog.html"><i className="fas fa-caret-right"></i> IT Service <span>5</span></a></li>
                                    </ul>
                                </div> */}
                                {recent_news_card_data.length > 0 ? (
                                    <div className="widget widget-recent-post">
                                        <h4 className="widget-title">Recent Blogs</h4>
                                        {/* <ul>
                                            {recent_news_card_data.map((card, index) => (
                                                <RecentNewsCard key={index} data={card} />
                                            ))}
                                        </ul> */}
                                    </div>
                                ) : (
                                    <div className="widget widget-recent-post">
                                        <h4 className="widget-title">Recent Blogs</h4>
                                        <p>No recent blogs available</p>
                                    </div>
                                )}
                                {/* <div className="widget widget_tag_cloud mb-0">
                                    <h4 className="widget-title">Tags</h4>
                                    <div className="tagcloud">
                                        <a href="#">Crazy Games</a>
                                        <a href="#">Post Type</a>
                                        <a href="#">Who Stickman Hook </a>
                                        <a href="#">Playhop</a>
                                    </div>
                                </div> */}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}